import React from "react";
import Top from "./top/Top";
import Banner from "./banner/Banner";
import Menu from "./menu/Menu";
import Intro from "./intro/Intro";
import Slider from "./slider/Slider";
import Timetable from "./timetable/Timetable";
// import Disabled from "./timetable/Disabled";
import Reservation from "./reservation/Reservation";
// import TimetableSummer from "./timetable/TimetableSummer";
import Christmas from "./banner/Christmas";
import Repairs from "./banner/Repairs";
import Prices from "./prices/Prices";
import Academy from "./academy/Academy";
import Footer from "./footer/Footer";
import "./App.scss";

function Landing() {
  return (
    <React.Fragment>
      <Top />
      {/* <Menu /> */}
      <div className="container">
        <Intro />
      </div>
      <Slider />
      {/* <Banner /> */}
      {/* <Christmas /> */}
      {/* <Repairs /> */}
      <div className="container">
        <Timetable />
        <Prices />
        <Academy />
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default Landing;
